/* global Clipboard extKey */

import DragBox from '../node_modules/ol/interaction/DragBox.js';
import {platformModifierKeyOnly, shiftKeyOnly} from '../node_modules/ol/events/condition.js';
import {unByKey} from '../node_modules/ol/Observable.js';

import {detailTab, renderInfo} from './renderInfo.js';
// import HoverStyle from './HoverStyle.js';

/* constructor */
export default function(map) {
  var eventListener;
  var infoBox;
  var clipboard;

  if (typeof Clipboard === 'function' && document.getElementById('infoTab') ) {  // mobile version doesn't have clipboard
    clipboard = new Clipboard('#copy-button', {
      text: function() {
        let dat = rwg.selection.tabDelimit();
        return dat || null;
      }
    });
    clipboard.on('success', function() {
      alert("Info has been copied to your computer's clipboard\n as TAB separated values and can now be pasted\n  into a spreadsheet or similar program.");  // eslint-disable-line quotes
    });
    clipboard.on('error', function(e) {
      alert('Unable to copy to clipboard.\nYour browser may be too old or incompatible');
      console.error(e);
    });
  }

  /** infoToolClickHandler()
   *  @param {event} evt
   */
  function click(evt) {
    let url
    // evt.originalEvent doesn't exist with 'boxend' events
    // look at https://openlayers.org/en/latest/examples/hit-tolerance.html
    let touchMultiplier = (evt?.originalEvent?.pointerType === 'touch') ? 4 : 1
    let serverInfoLayers = rwg.layers.getActiveInfoLayers();  // string of server-side info layer names
    // let localInfoLayers = rwg.layers.getActiveLocalInfoLayers();  // array of client-side info layer names
    if (map.getTarget() === 'pmap') return; // don't doing anything in print layout

    detailTab(false); // clear any existing property detail as it will likely not correspond to new info from this click

    if (serverInfoLayers) { /*( serverInfoLayers || localInfoLayers) */
      if (serverInfoLayers) {
        url = rwg.config.info_url + 'layers=' + serverInfoLayers;
        url += '&r=' + Math.round(map.getView().getResolution() * touchMultiplier * 10) / 10;  // resolution in map units per pixel
      }
      // if it's a click then inspect evt.pointerEvent
      // else if it's a box inspect evt.mapBrowserEvent.pointerEvent
      // evt.mapBrowserEvent.pointerEvent.shiftKey;  // altKey
      // evt.mapBrowserEvent.pointerEvent.metaKey;
      // Will ALWAYS be 'boxend' when mode==box
      if (evt.type === 'singleclick' || evt.type === 'pointerdrag') {
        rwg.selection.method = 'point'
        if (serverInfoLayers) {
          const p = rwg.proj.transform(rwg.proj.mapSRID, rwg.proj.dataSRID, evt.coordinate)
          url += '&p=' + p.map(e => Math.round(e)).toString() // use Array.map() to round the coordinates and then convert to a string
          if (typeof extKey !== 'undefined') {
            extKey.shiftKey = shiftKeyOnly(evt)
          }
        }

        /*
        if (localInfoLayers) {
          let numRows = 0;
          let info = [];
          map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {

            rwg.layers.getLayersBy('olLyr', layer.get('title')).forEach(function(userLayer) { // get the userLayer(s) for the olLayer
              if (localInfoLayers.indexOf(userLayer.name) > -1) {  // does the user layer have an infov function?
                info.push({ // this is formatting to match the server-side info format, which may not be the best
                  handler: userLayer.name,
                  // records: [feature.getProperties()],
                  feature: feature  // adding the whole feature so that it, and its styles, can be edited
                });
                numRows++;
              }
            });
          });

          // * expected format (server-side php generated JSON) shown below requires more work
          // * numRows is total from all layers - probably okay, numRows might not be used anyway
          // * and all of a layer's records are grouped into one info array element
          // * whereas here we've got an info array element for each row
          // * TODO group all records in a layer into a single info array element
          //  {
          //    info [
          //      {
          //        handler: "manhole"
          //        records: [
          //          ['{"sems_name":"MH-G 410","flow_type":null,"remarks":null,"life_expec":50}']
          //          ['{"sems_name":"MH-G 411","flow_type":null,"remarks":null,"life_expec":50}']
          //        ]
          //      },
          //      {
          //        handler: "ownership",
          //        records: Array(4)
          //      }
          //    ],
          //    numRows: 6
          //  }

          rwg.renderInfoContent({   // this gets called here and in rwg.renderInfo() above
                                    // which results in two calls and thus 2 calls to
                                    // changePage() which messes up history
            numRows: numRows,
            info: info
          });
        }
          // -- sample desk-conf.js vector info function
             --    infov: function(feature) {   // this is just a vector info test - NOT FOR PRODUCTION
             --      console.log('kludgy reformatting for rwg.formatInfo(), should allow formatInfo() to accept JSON');
             --      return rwg.editableAttributes(feature);
             --      let format = [];
             --      let row = [];
             --      records.forEach(function(rec) {
             --        for (const prop in rec) {
             --          format.push([prop]);
             --          row.push(rec[prop]);
             --        }
             --      });
             --      return rwg.formatInfo([row], format);
             --      // feature.forEach( function(feature) {
             --        rwg.editableAttributes(feature) // in wfs.js, expects a feature
             --      // });
             --    },
             -- //

        */

      } else if (evt.type === 'boxend') {
        rwg.selection.method = 'box'
        if (serverInfoLayers) {
          const boxExtent = this.getGeometry().getExtent()
          if (Math.abs(boxExtent[0] - boxExtent[2] + boxExtent[1] - boxExtent[3]) > 0) {  // it really is a box
            const min = rwg.proj.transform(rwg.proj.mapSRID, rwg.proj.dataSRID, boxExtent.slice(0,2))
            const max = rwg.proj.transform(rwg.proj.mapSRID, rwg.proj.dataSRID, boxExtent.slice(2))
            const box = min.concat(max).map(e => Math.round(e)).toString()
            url += '&b=' + box
          } else { // do it as a point which will buffer it
            rwg.selection.method = 'point'
            const p0 = rwg.proj.transform(rwg.proj.mapSRID, rwg.proj.dataSRID, boxExtent.slice(0,2))
            url += '&p=' + p0.map(e => Math.round(e)).toString() // using Array.map() to round the coordinates and then convert to a string
          }
          if (typeof extKey !== 'undefined') extKey.shiftKey = shiftKeyOnly(evt.mapBrowserEvent);
        }
        /*
        if (localInfoLayers) {
          // FIXME vector stuff not tested
          let numRows = 0;
          let info = [];
          localInfoLayers.forEach( function(userLayerName) {
            let userLayer = rwg.layers.getLayerByName(userLayerName);
            let infoGroup;
            let olLayer = map.getLayerByTitle(userLayer.olLyr);
            if (olLayer) {
              infoGroup = {
                handler: userLayerName,
                records: []
              };
              olLayer.getSource().forEachFeatureIntersectingExtent(
                this.getGeometry().getExtent(),
                function(feature) {
                  infoGroup.records.push([feature.getProperties()]);
                  numRows++;
                  // userLayer.info(feature);  // combine this with above of new function(feature, vectorInfoLayerName)
                }
              );
            }
            info.push(infoGroup);
          });

          rwg.renderInfoContent({
            numRows: numRows,
            info: info
          });
        }  // vector
        */
      }  // box

      if (serverInfoLayers) renderInfo(url); // there is a server-side layer
    }
    rwg.sidePanel.show();
  }

  /** the only public method of InfoTool
   *  enables/disables click & drag listeners
   */
  function info(mode, evt) {
    var dragBoxOptions = {};
    switch(mode) {
      case 'off':
        unByKey(eventListener);  // disable single click
        map.removeInteraction(infoBox);  // disable info DragBox
        document.querySelector('[data-ol-map]').style.cursor = 'auto';
        break;
      case 'on':
        eventListener = map.on('singleclick', click);
        dragBoxOptions.condition = platformModifierKeyOnly; // only when dragging w/ Control key
        // eslint-disable-next-line no-fallthrough
      case 'box':
        if (mode === 'box') { // always fire, even on small move
          dragBoxOptions.boxEndCondition = function() { return true; };
        }
        infoBox = new DragBox(dragBoxOptions);
        map.addInteraction(infoBox);
        infoBox.on('boxend', click);
        document.querySelector('div[data-ol-map]').style.cursor = 'help';
        break;
      case 'click': // manually fire the click event, called when small drag occurs
        click(evt);
        break;
    }
  }

  // new HoverStyle();

  info('on');
  return info;
}
